var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.571,
    viewBox: "0 0 20 18.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M21.491,9.8H14.924l-2-5.955a.723.723,0,0,0-1.357,0l-2,5.955H2.964a.716.716,0,0,0-.714.714.525.525,0,0,0,.013.121.686.686,0,0,0,.3.5l5.4,3.8L5.888,20.969a.716.716,0,0,0,.246.8.691.691,0,0,0,.4.174.875.875,0,0,0,.446-.161l5.268-3.754,5.268,3.754a.837.837,0,0,0,.446.161.641.641,0,0,0,.4-.174.708.708,0,0,0,.246-.8l-2.071-6.022,5.353-3.839L22.018,11a.749.749,0,0,0,.232-.478A.756.756,0,0,0,21.491,9.8Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#ffe200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.dd437b12.svg";
export { ForwardRef as ReactComponent };